import React from "react";
import "./index.css";
import { ReactComponent as Cash } from "./assets/money.svg";
import { ReactComponent as Debit } from "./assets/debit.svg";
import { ReactComponent as POS } from "./assets/pos.svg";
import BenefitTransfer from "./assets/benefit.png";
import WalletIcon from "../CheckoutProcess/assets/wallet.png";
import { ReactComponent as Star } from "../PromotionalStoreFront/assets/star.svg";

import { connect } from "react-redux";
import { OfflinePaymentsMethods } from "../CheckoutProcess/Confirmation";

function PaymentInfo({ order, language, settings }) {
  const currency =
    language === "english"
      ? settings.base_currency
      : settings.base_currency_local;
  const capitalizeWords = (str) => {
    if (typeof str !== "string") return "";
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };
  const t = (str) => {
    const trans = {
      cash: "كاش",
      wallet: "محفظة",
      kod: "دفع عند الاستلام",
      "loyalty points": "نقاط الولاء",
    };
    if (language == "english" && str === "kod") return "Upon delivery";
    if (language === "english")
      return Object.keys(trans).includes(str.toLowerCase()) ? str : "Online";
    else
      return Object.keys(trans).includes(str.toLowerCase())
        ? trans[str.toLowerCase()]
        : "اونلاين";
  };
  const getPaymentMethod = () => {
    if (order.payment_method == "cash")
      return (
        <>
          <Cash style={{ width: 25, height: 25 }} />
          <span>{language == "english" ? "Cash" : "كاش"}</span>
        </>
      );
    if (order.payment_method == "kod")
      return (
        <>
          <POS style={{ width: 25, height: 25 }} />
          <span style={{ fontSize: 13 }}>
            {/*{language == "english" ? "KNET on Delivery" : "كي نت عند الاستلام"}*/}
            {language == "english"
              ? settings.custom_texts.pay_with_knet_machine
              : settings.custom_texts.pay_with_knet_machine_ar}
          </span>
        </>
      );
    if (order.payment_method == "wallet")
      return (
        <>
          <img src={WalletIcon} width="25" height="25" alt="wallet" />{" "}
          <span style={{ fontSize: 13 }}>
            {language == "english" ? "Wallet" : "محفظة"}
          </span>
        </>
      );
    if (order.payment_method == "loyalty points")
      return (
        <>
          <Star
            style={{
              width: 25,
              height: 25,
            }}
          />
          <span style={{ fontSize: 13 }}>
            {language == "english" ? "Loyalty Points" : "نقاط الولاء"}
          </span>
        </>
      );
    if (order.payment_method == "benefit-transfer")
      return (
        <>
          <img src={BenefitTransfer} style={{ width: 25, height: 25 }} />{" "}
          <span style={{ fontSize: 13 }}>
            {language == "english" ? "Benefit Pay" : "تحويل بينيفت"}
          </span>
        </>
      );
    else if (order.payment_method.includes(","))
      return (
        <>
          <Debit style={{ width: 25, height: 25 }} />
          <span>{order.payment_method.split(",").join(" and ")}</span>
        </>
      );
    else
      return (
        <>
          <Debit style={{ width: 25, height: 25 }} />
          <span>{language == "english" ? "Online" : "اونلاين"}</span>
        </>
      );
  };
  return (
    <div
      className="row border mt-4"
      style={{
        backgroundColor: "white",
        minHeight: 65,
        padding: "15px 5px",
        marginLeft: 0,
        marginRight: 0,
      }}
    >
      <div
        className={"col-6 d-flex ".concat(
          language == "english" ? "text-left" : "text-right"
        )}
      >
        <span className="my-auto bold">
          {language == "english" ? "Payment Method:" : "طريقة الدفع:"}
        </span>
      </div>
      <div className="col-6 d-flex ">
        <span
          className={"my-auto ".concat(
            language == "english" ? "ml-auto" : "mr-auto"
          )}
        >
          {getPaymentMethod()}
        </span>
      </div>
      {order.payments.length > 1
        ? order.payments.map((payment, index) => (
            <React.Fragment key={index}>
              <div
                className={"col-4 d-flex pt-3 ".concat(
                  language === "english" ? "text-left" : "text-right"
                )}
              >
                <span className="my-auto bold">
                  {t(capitalizeWords(payment?.payment_method))}
                </span>
              </div>

              <div className="col-4 d-flex pt-3">
                <span
                  className={`my-auto bold ${
                    payment?.payment_complete ? "text-success" : "text-danger"
                  }`}
                >
                  {payment?.payment_complete
                    ? language === "english"
                      ? "Paid"
                      : "مدفوع"
                    : language === "english"
                    ? "Not Paid"
                    : "غير مدفوع"}
                </span>
              </div>

              <div
                className={"col-4 d-flex pt-3 ".concat(
                  language === "english" ? "text-right" : "text-left"
                )}
              >
                <span
                  className={"my-auto bold ".concat(
                    language === "english" ? "ml-auto" : "mr-auto"
                  )}
                >
                  {payment?.amount?.toFixed(3)} {currency}
                </span>
              </div>
            </React.Fragment>
          ))
        : null}

      {!OfflinePaymentsMethods.includes(order.payment_method) &&
      order.payment_payid ? (
        <>
          <div
            className={"col-6 d-flex ".concat(
              language == "english" ? "text-left" : "text-right"
            )}
            style={{ marginTop: 20 }}
          >
            <span className="my-auto bold">
              {language == "english" ? "Result" : "النتيجة"}:
            </span>
          </div>
          <div className="col-6 d-flex " style={{ marginTop: 20 }}>
            <span
              className={"my-auto ".concat(
                language == "english" ? "ml-auto" : "mr-auto"
              )}
            >
              {language == "english" ? "CAPTURED" : "ناجحة"}
            </span>
          </div>
          {order.payment_reference !== order.payment_payid && (
            <>
              <div
                className={"col-6 d-flex ".concat(
                  language == "english" ? "text-left" : "text-right"
                )}
                style={{ marginTop: 20 }}
              >
                <span className="my-auto bold">Payment ID:</span>
              </div>
              <div className="col-6 d-flex " style={{ marginTop: 20 }}>
                <span
                  className={"my-auto ".concat(
                    language == "english" ? "ml-auto" : "mr-auto"
                  )}
                >
                  {order.payment_payid}
                </span>
              </div>
            </>
          )}

          {!!order.payment_reference && (
            <>
              <div
                className={"col-6 d-flex ".concat(
                  language == "english" ? "text-left" : "text-right"
                )}
                style={{ marginTop: 20 }}
              >
                <span className="my-auto bold">
                  {language == "english" ? "Reference" : "المرجع"}:
                </span>
              </div>
              <div className="col-6 d-flex " style={{ marginTop: 20 }}>
                <span
                  className={"my-auto ".concat(
                    language == "english" ? "ml-auto" : "mr-auto"
                  )}
                >
                  {order.payment_reference}
                </span>
              </div>
            </>
          )}

          <div
            className={"col-6 d-flex ".concat(
              language == "english" ? "text-left" : "text-right"
            )}
            style={{ marginTop: 20 }}
          >
            <span className="my-auto bold">
              {language == "english" ? "Date" : "التاريخ"}:
            </span>
          </div>
          <div className="col-6 d-flex " style={{ marginTop: 20 }}>
            <span
              className={"my-auto ".concat(
                language == "english" ? "ml-auto" : "mr-auto"
              )}
            >
              {order.placed}
            </span>
          </div>
        </>
      ) : null}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    settings: state.store.store.settings,
  };
};
export default connect(mapStateToProps)(PaymentInfo);
